/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import { Button } from "@mui/material";

import Styles from "./btn.module.scss";
const DefaultBtn = observer(() => {
  const { t } = useTranslation();
  return (
    <Button variant="contained" fullWidth disabled={true} className={Styles.commonBtn}>
      {t("checkout.common.placeOrderBtn")}
    </Button>
  );
});

export default DefaultBtn;
